export default __webpack_public_path__ + "static/media/CNo.79-4.e4c09605.jpg";